import { render, staticRenderFns } from "./mobRegister.vue?vue&type=template&id=3bfa4272&scoped=true"
import script from "./mobRegister.vue?vue&type=script&lang=js"
export * from "./mobRegister.vue?vue&type=script&lang=js"
import style0 from "./mobRegister.vue?vue&type=style&index=0&id=3bfa4272&prod&lang=scss"
import style1 from "./mobRegister.vue?vue&type=style&index=1&id=3bfa4272&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa4272",
  null
  
)

export default component.exports